export default __webpack_public_path__ + "static/flow-founders-8e7dca0deabf8b42b72346967a51f86b.jpg";